var exports = {
  "r3": "dialog__BcAV6i",
  "rf": "body__5otnoJ",
  "Qq": "text__wf8KOV",
  "GD": "primaryText__Ioob1W" + " " + "text__wf8KOV",
  "Yg": "secondaryText__pxVQd_" + " " + "text__wf8KOV",
  "DU": "surveyLink__FAsLcy",
  "r_": "noThanksButton__LTXGTA",
};

module.exports = exports;
